export {
    Headline1,
    Headline2,
    Headline3,
    Headline4,
    H1 as H1Compatible,
    H2 as H2Compatible,
    H3 as H3Compatible,
    H4 as H4Compatible,
} from '@sberdevices/plasma-core';
